import { Component } from '@angular/core';

@Component({
  selector: 'app-await-proctor',
  templateUrl: './await-proctor.component.html',
  styleUrls: ['./await-proctor.component.css']
})
export class AwaitProctorComponent {

}
